// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-header {
    display: inline-block;
    width: 100%;
    height: var(--header-height);
    padding: 10px;
    border-bottom: 5px solid var(--primary-color);
    box-sizing: border-box;
    margin: 0;
    position: fixed;
    z-index: 20;
    background-color: white;
    top: 0;
}

:root {
    --logo-image-width: 140px;
}

.app-header img {
    width: var(--logo-image-width);
    margin: 0;
    padding: 0;
    display: inline-block;
    vertical-align: middle;
}

.app-header .app-header--right {
    display: inline-block;
    vertical-align: middle;
    text-align: right;
    width: calc(100% - var(--logo-image-width));
}

.app-header .app-header--right>div {
    margin-bottom: 5px;
}


.app-header .app-header--right>div>span {
    margin-left: 8px;
}

.app-header--centered {
    display: inline-block;
    width: calc(100% - var(--logo-image-width) - 200px);
    position: fixed;
    top: 4px;
    left: var(--logo-image-width);
    margin-left: 50px;
    padding: 5px;
    text-align: center;
    font-size: 15px;

    pointer-events: none;
}

.enrolment-locked-icon {
    position: absolute;
    left: -20px;
    top: calc(var(--header-height) / 2 - 20px);
}

.app-header--centered .save-button,
.app-header--centered .recently-saved-icon {
    position: absolute;
    left: -20px;
    top: calc(var(--header-height) / 2 - 20px);
}`, "",{"version":3,"sources":["webpack://./src/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,WAAW;IACX,4BAA4B;IAC5B,aAAa;IACb,6CAA6C;IAC7C,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,MAAM;AACV;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,SAAS;IACT,UAAU;IACV,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,mDAAmD;IACnD,eAAe;IACf,QAAQ;IACR,6BAA6B;IAC7B,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;;IAEf,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,0CAA0C;AAC9C;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,0CAA0C;AAC9C","sourcesContent":[".app-header {\n    display: inline-block;\n    width: 100%;\n    height: var(--header-height);\n    padding: 10px;\n    border-bottom: 5px solid var(--primary-color);\n    box-sizing: border-box;\n    margin: 0;\n    position: fixed;\n    z-index: 20;\n    background-color: white;\n    top: 0;\n}\n\n:root {\n    --logo-image-width: 140px;\n}\n\n.app-header img {\n    width: var(--logo-image-width);\n    margin: 0;\n    padding: 0;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.app-header .app-header--right {\n    display: inline-block;\n    vertical-align: middle;\n    text-align: right;\n    width: calc(100% - var(--logo-image-width));\n}\n\n.app-header .app-header--right>div {\n    margin-bottom: 5px;\n}\n\n\n.app-header .app-header--right>div>span {\n    margin-left: 8px;\n}\n\n.app-header--centered {\n    display: inline-block;\n    width: calc(100% - var(--logo-image-width) - 200px);\n    position: fixed;\n    top: 4px;\n    left: var(--logo-image-width);\n    margin-left: 50px;\n    padding: 5px;\n    text-align: center;\n    font-size: 15px;\n\n    pointer-events: none;\n}\n\n.enrolment-locked-icon {\n    position: absolute;\n    left: -20px;\n    top: calc(var(--header-height) / 2 - 20px);\n}\n\n.app-header--centered .save-button,\n.app-header--centered .recently-saved-icon {\n    position: absolute;\n    left: -20px;\n    top: calc(var(--header-height) / 2 - 20px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
